/**
 * Romanian UI labels for UiBlocks components
 */

export const LABELS = {
  // Price
  PRICE_SUFFIX: 'cu TVA',
  MSRP_PREFIX: 'PRP:',

  // Buttons
  ADD_TO_CART: 'Adauga in cos',
  VIEW_DETAILS: 'Vezi detalii',
  ADD_TO_WISHLIST: 'Adauga la favorite',
  REMOVE_FROM_WISHLIST: 'Sterge de la favorite',
} as const

/**
 * Type for LABELS keys (useful for props that accept label keys)
 */
export type LabelKey = keyof typeof LABELS
